var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('Breadcrumbs',{attrs:{"items":_vm.items}}),_c('v-sheet',{staticClass:"transparent-background-color"},[_c('v-row',{staticClass:"mx-2 my-1"},[_c('v-col',{attrs:{"cols":"12","md":"8"}},[_c('v-row')],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }